import { render, staticRenderFns } from "./organizeTree.vue?vue&type=template&id=5471645e&scoped=true"
import script from "./organizeTree.vue?vue&type=script&lang=js"
export * from "./organizeTree.vue?vue&type=script&lang=js"
import style0 from "./organizeTree.vue?vue&type=style&index=0&id=5471645e&prod&lang=scss&scoped=true"
import style1 from "./organizeTree.vue?vue&type=style&index=1&id=5471645e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5471645e",
  null
  
)

export default component.exports